if (typeof window.WishlistPlusUILayoutAPI === 'undefined') {
  window.WishlistPlusUILayoutAPI = {}
}

if (typeof window.WishlistPlusListUIContext === 'undefined') {
  window.WishlistPlusListUIContext = {}
}

WishlistPlusListUIContext.CustomEvents = {
  SwymWishlistFetched: 'SwymWishlistFetched',
  SwymWishlistAsyncApisInitialized: 'SwymWLAsyncApisInitialized',
}

const swymInitWishlistAsyncApi = (swat) => {
  const SwymWishlistPlusListDefaultName =
    swat.retailerSettings.UI.Title || 'my wishlist'

  const SwymWLAsyncApis = {
    fetchLists: async () =>
      new Promise((resolve, reject) => {
        swat.api.fetchLists({
          callbackFn: (lists) => resolve(lists),
          errorFn: (err) => reject(err),
        })
      }),
    fetchListDetails: async (lid) =>
      // biome-ignore lint/suspicious/noAsyncPromiseExecutor: <explanation>
      new Promise(async (resolve, reject) => {
        swat.api.fetchListDetails(
          { lid: lid },
          (listContents) => resolve(listContents),
          (error) => reject(error),
        )
      }),
    fetchListProductsDetails: async (lid) =>
      // biome-ignore lint/suspicious/noAsyncPromiseExecutor: <explanation>
      new Promise(async (resolve, reject) => {
        swat.api.fetchListCtx(
          { lid: lid },
          (listContents) => resolve(listContents),
          (error) => reject(error),
        )
      }),
    createList: async (listName = SwymWishlistPlusListDefaultName) => {
      const listConfig = { lname: listName }
      // biome-ignore lint/suspicious/noAsyncPromiseExecutor: <explanation>
      return new Promise(async (resolve, reject) => {
        swat.api.createList(
          listConfig,
          (list) => resolve(list),
          (error) => reject(error),
        )
      })
    },
    renameList: (lid, lname = SwymWishlistPlusListDefaultName) => {
      const listUpdateConfig = {
        lname,
        lid,
      }
      // biome-ignore lint/suspicious/noAsyncPromiseExecutor: <explanation>
      return new Promise(async (resolve, reject) => {
        swat.api.updateList(
          listUpdateConfig,
          (list) => resolve(list),
          (error) => reject(error),
        )
      })
    },
    deleteLists: async (lists) => {
      try {
        await Promise.all(
          lists.map(
            (list) =>
              new Promise((resolve, reject) => {
                swat.api.deleteList(
                  list.lid,
                  (obj) => resolve(obj),
                  (error) => reject(error),
                )
              }),
          ),
        )
        return { success: true }
      } catch (error) {
        console.error('Error encountered while deleting the list', error)
        throw error
      }
    },
    addProductsToList: async (products, lid) =>
      // biome-ignore lint/suspicious/noAsyncPromiseExecutor: <explanation>
      new Promise(async (resolve, reject) => {
        swat.api.addProductsToList(
          lid,
          products,
          (products) => resolve(products),
          (error) => reject(error),
        )
      }),
    removeProductFromList: async (product, lid) =>
      // biome-ignore lint/suspicious/noAsyncPromiseExecutor: <explanation>
      new Promise(async (resolve, reject) => {
        swat.api.deleteFromList(
          lid,
          product,
          (deletedProduct) => resolve(deletedProduct),
          (error) => reject(error),
        )
      }),
    updateProductFromList: async (product, lid) =>
      // biome-ignore lint/suspicious/noAsyncPromiseExecutor: <explanation>
      new Promise(async (resolve, reject) => {
        swat.api.updateListItem(
          lid,
          product,
          (updatedListItem) => resolve(updatedListItem),
          (error) => reject(error),
        )
      }),
    getListsProducts: async (lists) =>
      Object.values(
        (
          await Promise.all(
            lists.map(async (list) =>
              SwymWLAsyncApis.fetchListProductsDetails(list.lid),
            ),
          )
        )
          .flat()
          .reduce((acc, { epi, empi, du }) => {
            acc[epi] = { epi, empi, du }
            return acc
          }, {}),
      ),
    generateSharedListURL: async (lid) =>
      // biome-ignore lint/suspicious/noAsyncPromiseExecutor: <explanation>
      new Promise(async (resolve, reject) => {
        swat.api.generateSharedListURL(
          lid,
          (link) => resolve(link),
          (error) => reject(error),
        )
      }),
    sendExtensionHeartbeat: async (
      extensionName,
      extensionType = 'app-embed',
    ) => {
      try {
        if (extensionName && extensionType) {
          const { pid, swymHost } = swat

          const regId = swat?.getSwymRegistrationId()
          const sessionId = swat?.session.getSessionId()

          const url = `${swymHost}/api/v3/provider/instrument/heartbeat/extensions`
          const qParams = new URLSearchParams({ pid })

          const reqBody = new URLSearchParams({
            regid: regId,
            sessionid: sessionId,
            'extension-name': extensionName,
            'extension-type': extensionType,
            'app-name': 'Wishlist',
            'theme-id': 'global',
          })

          const myHeaders = new Headers()
          myHeaders.append(
            'Content-Type',
            'application/x-www-form-urlencoded;charset=UTF-8',
          )
          myHeaders.append('Accept', 'application/json')
          myHeaders.append('user-agent', navigator.userAgent)

          const response = await fetch(`${url}?${qParams}`, {
            method: 'POST',
            headers: myHeaders,
            body: reqBody,
          })

          const resJson = await response.json()

          if (response.ok) {
            return { success: true, data: resJson }
          }
          return { success: false, data: resJson }
        }
      } catch (error) {
        console.log('[Error] Failed to send extension heart beat', error)
        return { success: false, data: error }
      }
    },
    init: async () => {
      SwymWLAsyncApis.updateList()

      console.log('Swym fetch default list - SUCCESS')
    },
    updateList: async () => {
      const defaultListName = SwymWishlistPlusListDefaultName.toLowerCase()

      const lists = (await SwymWLAsyncApis.fetchLists()) || []

      // If no lists, create a new list
      if (!lists.length) {
        const newList = await SwymWLAsyncApis.createList()
        lists.push(newList)
      }

      let defaultList = lists.find(
        (list) => list.lname.toLowerCase() === defaultListName,
      )
      const collections = lists.filter(
        (item) => item.lname.toLowerCase() !== defaultListName,
      )

      if (!defaultList) {
        defaultList = await SwymWLAsyncApis.createList()
        lists.push(defaultList)
      }

      WishlistPlusListUIContext.WishlistListDefaultList = defaultList
      WishlistPlusListUIContext.WishlistListLists = lists
      WishlistPlusListUIContext.WishlistListCollections = collections?.sort(
        (a, b) => b.uts - a.uts,
      )

      const event = new CustomEvent(
        WishlistPlusListUIContext.CustomEvents.SwymWishlistFetched,
        {
          detail: { defaultList, collections, lists },
        },
      )
      document.dispatchEvent(event)

      return lists
    },
  }

  WishlistPlusUILayoutAPI.SwymWLAsyncApis = SwymWLAsyncApis
  const event = new CustomEvent(
    WishlistPlusListUIContext.CustomEvents.SwymWishlistAsyncApisInitialized,
    { detail: { SwymWLAsyncApis } },
  )
  document.dispatchEvent(event)
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = []
}
window.SwymCallbacks.push(swymInitWishlistAsyncApi)
